import { render } from "./oficialiaRecepcionOficios.vue?vue&type=template&id=07a90edd&scoped=true"
import script from "./oficialiaRecepcionOficios.vue?vue&type=script&lang=js"
export * from "./oficialiaRecepcionOficios.vue?vue&type=script&lang=js"

import "./oficialiaRecepcionOficios.vue?vue&type=style&index=0&id=07a90edd&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a90edd"]])

export default __exports__